"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LottoSmallDtoToJSON = exports.LottoSmallDtoFromJSONTyped = exports.LottoSmallDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function LottoSmallDtoFromJSON(json) {
    return LottoSmallDtoFromJSONTyped(json, false);
}
exports.LottoSmallDtoFromJSON = LottoSmallDtoFromJSON;
function LottoSmallDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'idLotto': !runtime_1.exists(json, 'idLotto') ? undefined : json['idLotto'],
        'nomeLotto': !runtime_1.exists(json, 'nomeLotto') ? undefined : json['nomeLotto'],
    };
}
exports.LottoSmallDtoFromJSONTyped = LottoSmallDtoFromJSONTyped;
function LottoSmallDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'idLotto': value.idLotto,
        'nomeLotto': value.nomeLotto,
    };
}
exports.LottoSmallDtoToJSON = LottoSmallDtoToJSON;
